import { AsyncState, Updater, unloadedAsyncState } from "widgets-for-react"
import { PaymentMethodState, initialPaymentMethodState } from "../../forms/paymentMethod/paymentMethodState"
import { SubscriptionResult } from "../subscriptionState"


export type ChangePaymentMethodState = Partial<{
}> & {
  changePaymentMethod:AsyncState<SubscriptionResult>
  paymentMethodState:PaymentMethodState
  isValid():boolean
}

export const initialChangePaymentMethodState : ChangePaymentMethodState = {
  changePaymentMethod:unloadedAsyncState(),
  paymentMethodState:initialPaymentMethodState,
  isValid:function(this:ChangePaymentMethodState) { 
    return this.paymentMethodState.isValid() }
}

export const changePaymentMethodUpdaters = {
  changePaymentMethod:(u:Updater<ChangePaymentMethodState["changePaymentMethod"]>) : Updater<ChangePaymentMethodState> =>
    s => ({...s, changePaymentMethod:u(s.changePaymentMethod)}),
  paymentMethodState:(u:Updater<ChangePaymentMethodState["paymentMethodState"]>) : Updater<ChangePaymentMethodState> =>
    s => ({...s, paymentMethodState:u(s.paymentMethodState)}),
}
